import Head from 'next/head';
import { NavBar } from 'components/shared/NavBar';
import Link from 'next/link';

const Page = () => {
	return (
		<>
			<Head>
				<title>AGB | Siccro Active Service</title>
				<meta
					name="description"
					content="Gereinigte Fenster sind eine gute Basis für ein angenehmes Wohnumfeld. Experten von SICCRO empfehlen, zusätzlich einige Pflegemaßnahmen durchzuführen, weil diese sich positiv auf die Lebensdauer auswirken und Ihnen dadurch Kosten sparen."
				/>
			</Head>
			<NavBar />
			<div className="mt-28 container text-4xl text-center md:pt-12 font-black  md:text-5xl mx-auto">
				<h2>Allgemeine Geschäftsbedingungen SYMAK AUSTRIA GmbH (AGB)</h2>
			</div>
			<div className=" max-w-[900px] text-xl pt-10 px-30 text-left flex flex-col mx-auto">
				<h3 className="text-2xl py-5 font-black">Geltung</h3>
				<p>
					Diese Geschäftsbedingungen gelten zwischen uns (SYMAK AUSTRIA GmbH) und natürlichen und juristischen
					Personen (kurz Kunde) für alle unternehmensbezogenen Lieferungen und Leistungen sowie auch für alle
					weiteren Geschäfte, selbst wenn im Einzelfall, insbesondere bei künftigen Ergänzungs- oder
					Folgeaufträgen darauf nicht ausdrücklich Bezug genommen wurde. <br />
					<br />
					Gerichtsstand für alle sich aus dem Vertragsverhältnis oder künftigen Verträgen zwischen uns und dem
					Kunden ergebenden Streitigkeiten ist das für unseren Sitz örtlich zuständige Gericht (siehe
					Impressum).
					<br />
					<br />
					Es gilt jeweils die bei Vertragsabschluss aktuelle Fassung unserer AGB, abrufbar auf unserer
					Homepage (www.siccro-fensterservice.at) und wurden diese auch an den Kunden übermittelt.
					<br />
					<br />
					Wir kontrahieren ausschließlich unter Zugrundelegung unserer AGB.
					<br />
					<br />
					Geschäftsbedingungen des Kunden oder Änderungen bzw. Ergänzungen unserer AGB bedürfen zu ihrer
					Geltung unserer ausdrücklichen schriftlichen Zustimmung.
					<br />
					<br />
					Geschäftsbedingungen des Kunden werden auch dann nicht anerkannt, wenn wir ihnen nach Eingang bei
					uns nicht ausdrücklich widersprechen.
					<br />
					<br />
					Das UN-Kaufrecht ist ausgeschlossen.
					<br />
					<br />
					Erfüllungsort ist der Sitz unseres Unternehmens: 5204 Straßwalchen, Salzburgerstrasse 26
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black"> Angebote, Vertragsabschluss</h3>
				<p>
					Unsere Angebote sind freibleibend und unverbindlich. <br />
					<br />
					Zusagen, Zusicherungen und Garantien unsererseits oder von diesen AGB abweichende Vereinbarungen im
					Zusammenhang mit dem Vertragsabschluss werden erst durch unsere Bestätigung verbindlich.
					<br />
					<br />
					Stillschweigen unsererseits gilt nicht als Zustimmung bzw. Annahme des Angebotes des Kunden.
					<br />
					<br />
					Wir behalten uns vor, die versprochene Leistung nicht zu erbringen, wenn sich nach Vertragsabschluss
					herausstellt, dass die Ware/Leistung nicht verfügbar ist, obwohl ein entsprechendes
					Verpflichtungsgeschäft abgeschlossen wurde. In einem solchen Fall erhält der Kunde unverzüglich
					Nachricht. Eventuell bereits erbrachte Gegenleistungen werden unverzüglich erstattet. Weitere
					Ansprüche gegen uns sind ausgeschlossen.
					<br />
					<br />
					Kostenvoranschläge werden ohne Gewähr erstellt und sind entgeltlich.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black"> Dauer</h3>
				<p>
					Das Vertragsverhältnis inkl. Zusatzoptionen wird auf die Dauer des gewünschten Pakets (12/24/48
					Monate) abgeschlossen und endet durch Zeitablauf. <br />
					<br />
					Dem Kunden steht es frei, den Vertrag während der gesetzlich eingeräumten Widerrufsfrist sofort
					aufzulösen.
					<br />
					<br />
					Wir (SYMAK AUSTRIA GmbH) behalten uns das Recht vor, das Vertragsverhältnis im Falle eines wichtigen
					Grundes jederzeit vorzeitig auflösen zu können. Dazu zählt insbesondere Zahlungsverzug trotz
					erfolgter Mahnung.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black"> Preise</h3>
				<p>
					Unsere Preise verstehen sich für das jeweilige Paket als Pauschalpreis. (All-in) <br />
					<br />
					Alle Preise sind in Euro (€) zu bezahlen.
					<br />
					<br />
					Das Entgelt bei unseren Paketen wird als wertgesichert nach dem VPI 2010 vereinbart und wird dadurch
					laufend angepasst. Als Ausgangsbasis wird der Monat zugrunde gelegt, in dem der Vertrag
					abgeschlossen wurde. Die Wertanpassung erfolgt jeweils zu Monatsbeginn.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Zahlung</h3>
				<p>
					Die erste Zahlung wird bei Vertragsabschlusses (Auftragsbestätigung) fällig. Die weiteren Zahlungen
					erfolgen immer wöchentlich im Voraus. <br />
					<br />
					Im Falle eines Verzuges werden die gesetzlichen Verzugszinsen berechnet.
					<br />
					<br />
					Diese betragen bei Verbrauchergeschäften gem. § 1000 ABGB bei verschuldetem Zahlungsverzug 4 %. Im
					Falle von Unternehmergeschäften betragen die Verzugszinsen 9,2 % Punkte über dem Basiszinssatz gem.
					§ 456 UGB.
					<br />
					<br />
					Kommt der Kunde im Rahmen anderer mit uns bestehender Vertragsverhältnisse in Zahlungsverzug, so
					sind wir berechtigt, die Erfüllung unserer Verpflichtungen aus diesem Vertrag bis zur Erfüllung
					durch den Kunden einzustellen.
					<br />
					<br />
					Der Kunde verpflichtet sich im Falle von Zahlungsverzug, die zur Einbringlichmachung notwendigen und
					zweckentsprechenden Kosten (Mahnkosten, Inkassogebühren, Rechtsanwaltskosten (RATG), etc.) an uns zu
					ersetzen.
					<br />
					<br />
					Die Geltendmachung eines weiteren Verzugsschadens behalten wir uns vor.
					<br />
					<br />
					Sofern eine Mahnung durch uns erfolgt, verpflichtet sich der Kunde ab der zweiten Mahnung einen
					Betrag von € 20,00 je Mahnung zu bezahlen.
					<br />
					<br />
					Der Kunde ist nicht zur Zurückbehaltung von Zahlungen berechtigt. Der Kunde hat kein Recht zur
					Aufrechnung mit allfälligen Gegenforderungen.
					<br />
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Mitwirkungspflichten des Kunden</h3>
				<p>
					Unsere Pflicht zur Leistungsausführung beginnt frühestens, sobald alle technischen Einzelheiten
					geklärt sind, der Kunde die technischen sowie rechtlichen Voraussetzungen (welche wir auf Anfrage
					gerne mitteilen) geschaffen hat, und der Kunde seine vertraglichen Vorleistungs- und
					Mitwirkungspflichtungen, insbesondere auch die in nachstehenden Unterpunkten genannten, erfüllt.{' '}
					<br />
					<br />
					Der Kunde haftet dafür, dass die notwendigen baulichen, technischen und rechtlichen Voraussetzungen
					für den angebotenen Service gegeben sind, die im Vertrag oder in vor Vertragsabschluss dem Kunden
					erteilten Informationen umschrieben wurden.
					<br />
					<br />
					Der Kunde ist bei von uns durchzuführenden Serviceleistungen verpflichtet, dafür zu sorgen, dass
					sofort nach Ankunft unseres Servicepersonals mit den Arbeiten begonnen werden kann.
					<br />
					<br />
					Auftragsbezogene Details der notwendigen Angaben können bei uns angefragt werden.
					<br />
					<br />
					Der Kunde ist nicht berechtigt, Forderungen und Rechte aus dem Vertragsverhältnis, ohne unsere
					schriftliche Zustimmung abzutreten.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Leistungsausführung</h3>
				<p>
					Wir sind lediglich dann verpflichtet, nachträgliche Änderungs- und Erweiterungswünsche des Kunden zu
					berücksichtigen, wenn sie aus technischen Gründen erforderlich sind, um den Vertragszweck zu
					erreichen.
					<br />
					<br />
					Dem Kunden zumutbare sachlich gerechtfertigte geringfügige Änderungen unserer Leistungsausführung
					gelten als vorweg genehmigt.
					<br />
					<br />
					Für vom Kunden speziell angeordnete Leistungen, die im ursprünglichen Auftrag keine Deckung finden,
					besteht Anspruch auf angemessenes Entgelt.
					<br />
					<br />
					Wünscht der Kunde nach Vertragsabschluss eine Leistungsausführung innerhalb eines kürzeren
					Zeitraums, stellt dies eine Vertragsänderung dar. Hierdurch können Überstunden notwendig werden
					und/oder durch die Beschleunigung der Materialbeschaffung Mehrkosten auflaufen, und erhöht sich das
					Entgelt im Verhältnis zum notwendigen Mehraufwand angemessen.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Liefer- und Leistungsfristen </h3>
				<p>
					Liefer-/Leistungsfristen und ‑ Termine sind für uns nur verbindlich, sofern sie schriftlich
					festgelegt wurden. Ein Abgehen von dieser Formvorschrift bedarf ebenfalls der Schriftlichkeit.
					<br />
					<br />
					Die vereinbarten Kundentermine werden nach Möglichkeit eingehalten, ohne dass sie den Charakter
					eines Fixgeschäftes nach §919 ABGB erhalten. Ansprüche auf Schadenersatz wegen leicht fahrlässig
					verursachten Leistungsverzugs sind ausgeschlossen.
					<br />
					<br />
					Fristen und Termine verschieben sich bei höherer Gewalt, Streik, nicht vorhersehbarer und von uns
					nicht verschuldeter Verzögerung durch unsere Zulieferer oder sonstigen vergleichbaren Ereignissen,
					die nicht in unserem Einflussbereich liegen, in jenem Zeitraum, währenddessen das entsprechende
					Ereignis andauert.
					<br />
					<br />
					Werden der Beginn der Leistungsausführung oder die Ausführung durch dem Kunden zuzurechnende
					Umstände verzögert oder unterbrochen, so werden Leistungsfristen entsprechend verlängert.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Unser geistiges Eigentum</h3>
				<p>
					Liefergegenstände und diesbezügliche Ausführungsunterlagen, Pläne, Skizzen, Kostenvoranschläge und
					sonstige Unterlagen sowie Software, die von uns beigestellt oder durch unseren Beitrag entstanden
					sind, bleiben unser geistiges Eigentum.
					<br />
					<br />
					Deren Verwendung, insbesondere deren Weitergabe, Vervielfältigung, Veröffentlichung und
					Zur-Verfügung-Stellung einschließlich auch nur auszugsweisen Kopierens, wie auch deren Nachahmung,
					Bearbeitung oder Verwertung bedarf unserer ausdrücklichen Zustimmung.
					<br />
					<br />
					Der Kunde verpflichtet sich weiters zur Geheimhaltung des ihm aus der Geschäftsbeziehung
					zugegangenen Wissens Dritten gegenüber.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Garantie</h3>
				<p>
					Im Falle von nicht zufriedenstellender Leistung gewähren eine anteilige Geld-zurück-Garantie für die
					erbrachten Leistungen.
					<br />
					<br />
					Dazu zählen unsachgemäße Reinigungs‑, Pflege- und Serviceleistungen.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Gewährleistung </h3>
				<p>
					Die Ausführung aller Leistungen erfolgt durch fachkundige Kräfte. Wir gewährleisten sachgemäße und
					sorgfältige Ausführung der Arbeit.
					<br />
					<br />
					Die Gewährleistungsfrist für unsere Leistungen beginnt am Tag der Ausführung der Leistung.
					<br />
					<br />
					Behebungen eines vom Kunden behaupteten Mangels stellen kein Anerkenntnis eines Mangels dar.
					<br />
					<br />
					Der Kunde hat stets zu beweisen, dass der Mangel zum Zeitpunkt der Übergabe bereits vorhanden war.
					<br />
					<br />
					Zur Behebung von Mängeln hat der Kunde die Anlage bzw. die Geräte ohne schuldhafte Verzögerung uns
					zugänglich zu machen und uns die Möglichkeit zur Begutachtung durch uns oder von uns bestellten
					Sachverständigen einzuräumen
					<br />
					<br />
					Unternehmer können Gewährleistungsansprüche nur geltend machen, wenn sie innerhalb von 14 Tagen nach
					Übernahme der Leistung eine Mängelrüge erheben. Die Beanstandungen sind am Sitz unseres Unternehmens
					unter möglichst genauer Fehlerbeschreibung und Angabe der möglichen Ursachen schriftlich bekannt zu
					geben.
					<br />
					<br />
					Für Verbraucher gelten die gesetzlichen Gewährleistungsregeln.
					<br />
					<br />
					Sind Mängelbehauptungen des Kunden unberechtigt, ist er verpflichtet, uns entstandene Aufwendungen
					für die Feststellung der Mängelfreiheit oder Fehlerbehebung zu ersetzen.
					<br />
					<br />
					Eine etwaige Nutzung oder Verarbeitung der Mangelhaften Leistung, durch welche ein weitergehender
					Schaden droht oder eine Ursachenbehebung erschwert oder verhindert wird, ist vom Kunden unverzüglich
					einzustellen, soweit dies nicht unzumutbar ist.
					<br />
					<br />
					Wir leisten keine Gewähr für Fehler oder Mängel, die auf unsachgemäße Bedienung, Verwendung oder
					Beanspruchung zurückzuführen sind. Außerdem leisten wir keine Gewähr bei Mängeln durch äußere
					Einwirkungen nach der Leistung oder Reparaturen oder sonstige Arbeiten, die von nicht autorisierten
					Dritten vorgenommen werden.
					<br />
					<br />
					Zur Mängelbehebung sind uns seitens des Kunden zumindest zwei Versuche einzuräumen.
					<br />
					<br />
					Im Falle eines auftretenden Mangels im Gewährleistungszeitraum sind wir berechtigt die Mängel
					zunächst entweder durch Verbesserung oder Ersatz der betreffenden Teile zu beheben. Erst dann
					besteht die Möglichkeit von Preisminderung und Vertragswandel.
					<br />
					<br />
					Keinen Mangel begründet der Umstand, dass das Werk zum vereinbarten Gebrauch nicht voll geeignet
					ist, wenn dies ausschließlich auf abweichende tatsächliche Gegebenheiten von den uns im Zeitpunkt
					der Leistungserbringung vorgelegenen Informationen basiert.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Haftung</h3>
				<p>
					Wegen Verletzung vertraglicher oder vorvertraglicher Pflichten, insbesondere wegen Unmöglichkeit,
					Verzug etc. haften wir bei Vermögensschäden nur in Fällen von Vorsatz oder grober Fahrlässigkeit
					aufgrund technischer Besonderheiten.
					<br />
					<br />
					Die Haftung ist beschränkt mit dem Haftungshöchstbetrag einer allenfalls durch uns abgeschlossenen
					Haftpflichtversicherung.
					<br />
					<br />
					Diese Beschränkung gilt auch hinsichtlich des Schadens an einer Sache, die wir zur Bearbeitung
					übernommen haben.
					<br />
					<br />
					Schadenersatzansprüche sind bei sonstigem Verfall binnen drei Jahren ab Kenntnis gerichtlich geltend
					zu machen.
					<br />
					<br />
					Die Beschränkungen bzw. Ausschlüsse der Haftung umfasst auch Ansprüche gegen unsere Mitarbeiter,
					Vertreter und Erfüllungsgehilfe aufgrund Schädigungen, die diese dem Kunden ohne Bezug auf einen
					Vertrag ihrerseits mit dem Kunden zufügen.
					<br />
					<br />
					Unsere Haftung ist ausgeschlossen für Schäden durch unsachgemäße Behandlung, Überbeanspruchung,
					Nichtbefolgen von Bedienungs- und Installationsvorschriften, Wartung, Instandhaltung durch den
					Kunden oder nicht von uns autorisierte Dritte, oder natürliche Abnutzung, sofern dieses Ereignis
					kausal für den Schaden war.
					<br />
					<br />
					Wenn und soweit der Kunde für Schäden, für die wir haften, Versicherungsleistungen durch eine eigene
					oder zu seinen Gunsten abgeschlossen Schadenversicherung (zB Haftpflichtversicherung, Kasko,
					Transport, Feuer, Betriebsunterbrechung und andere) in Anspruch nehmen kann, verpflichtet sich der
					Kunde zur Inanspruchnahme der Versicherungsleistung und beschränkt sich unsere Haftung gegenüber dem
					Kunden insoweit auf die Nachteile, die dem Kunden durch die Inanspruchnahme dieser Versicherung
					entstehen (z.B. höhere Versicherungsprämie).
					<br />
					<br />
					Jene Produkteigenschaften werden geschuldet, die im Hinblick auf die Zulassungsvorschriften,
					Bedienungsanleitungen und sonstige produktbezogene Anleitungen und Hinweise (insb. auch Kontrolle
					und Wartung) von uns, dritten Herstellern oder Importeuren vom Kunden unter Berücksichtigung dessen
					Kenntnisse und Erfahrungen erwartet werden können.
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Urheberrecht</h3>
				<p>
					Das Urheberrecht unserer eigenen Texte, Grafiken und Bilder steht SYMAK SWISS AG zu. Eine
					Vervielfältigung solcher Texte, Grafiken und Bilder in anderen elektronischen oder gedruckten
					Publikationen ist ohne unsere schriftliche Zustimmung nicht gestattet
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Salvatorische Klausel</h3>
				<p>
					Sollten einzelne Teile dieser AGB unwirksam sein, so wird dadurch die Gültigkeit der übrigen Teile
					nicht berührt.
					<br />
					<br />
					Die Parteien verpflichten sich jetzt schon eine Ersatzregelung – ausgehend vom Horizont redlicher
					Vertragsparteien – zu treffen, die dem wirtschaftlichen Ergebnis unter Berücksichtigung der
					Branchenüblichkeit der unwirksamen Bedingung am nächsten kommt.
					<br />
					<br />
					<br />
					<br />
				</p>
			</div>
		</>
	);
};

export default Page;
